import React from 'react'

const Contact = () => {
  return (
    <div>
      contact us
    </div>
  )
}

export default Contact
